import { render } from "./ValidateEmail.vue?vue&type=template&id=9da00494&scoped=true"
import script from "./ValidateEmail.vue?vue&type=script&lang=js"
export * from "./ValidateEmail.vue?vue&type=script&lang=js"

import "./ValidateEmail.vue?vue&type=style&index=0&id=9da00494&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9da00494"]])

export default __exports__